import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ChangePasswordType } from "store/types/profile";

const initialChangePasswordState: ChangePasswordType = {
  current_password: "",
  new_password: "",
};

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState: initialChangePasswordState,
  reducers: {
    setChangePassword: (state, action: PayloadAction<ChangePasswordType>) =>
      (state = action.payload),
  },
});

export const { setChangePassword } = changePasswordSlice.actions;
export default changePasswordSlice.reducer;
